import { useState, useEffect } from 'react'
import axios from 'axios'

const API_URL = 'https://link-bio-api.link-bio-saik.workers.dev'

function App() {
  const [links, setLinks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [newLink, setNewLink] = useState({ title: '', url: '' })

  useEffect(() => {
    fetchLinks()
  }, [])

  const fetchLinks = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${API_URL}/api/links`)
      setLinks(response.data.links || [])
      setError(null)
    } catch (err) {
      setError('Failed to load links')
      console.error('Error fetching links:', err)
    } finally {
      setLoading(false)
    }
  }

  const addLink = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${API_URL}/api/links`, {
        userId: 'demo-user',
        title: newLink.title,
        url: newLink.url,
        order: '0'
      })
      setNewLink({ title: '', url: '' })
      fetchLinks()
    } catch (err) {
      setError('Failed to add link')
      console.error('Error adding link:', err)
    }
  }

  const deleteLink = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/links/${id}`)
      fetchLinks()
    } catch (err) {
      setError('Failed to delete link')
      console.error('Error deleting link:', err)
    }
  }

  return (
    <div className="app">
      <header className="header">
        <h1>🔗 My Link Bio</h1>
        <p>Share all your links in one place</p>
      </header>

      <form onSubmit={addLink} className="add-form">
        <input
          type="text"
          placeholder="Link Title"
          value={newLink.title}
          onChange={(e) => setNewLink({ ...newLink, title: e.target.value })}
          required
        />
        <input
          type="url"
          placeholder="https://example.com"
          value={newLink.url}
          onChange={(e) => setNewLink({ ...newLink, url: e.target.value })}
          required
        />
        <button type="submit">Add Link</button>
      </form>

      {error && <div className="error">{error}</div>}

      <div className="links-container">
        {loading ? (
          <div className="loading">Loading...</div>
        ) : links.length === 0 ? (
          <div className="empty">No links yet. Add your first link!</div>
        ) : (
          links.map((link) => (
            <div key={link.id} className="link-card">
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                <span className="link-title">{link.title}</span>
                <span className="link-icon">↗</span>
              </a>
              <button 
                onClick={() => deleteLink(link.id)} 
                className="delete-btn"
              >
                ✕
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default App